function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.75 4C2.75 3.30964 3.30964 2.75 4 2.75H20C20.6904 2.75 21.25 3.30964 21.25 4V16C21.25 16.6904 20.6904 17.25 20 17.25H8.7241C8.08078 17.25 7.45781 17.4755 6.96359 17.8874L3.16004 21.057C2.99722 21.1927 2.75 21.0769 2.75 20.865V4Z",
  stroke: "#627080",
  strokeWidth: 1.5
});

const SvgComment2 = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgComment2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Comment-2.c2f076c5.svg";
export { ForwardRef as ReactComponent };